module.exports = global.config = {
  r0QiYek: "!q0RIHCM3ncrypTk",
};
